import {createAction, props} from '@ngrx/store';
import {
  KnowledgeArticleListDto,
  KnowledgeArticleStartDto, KnowledgeArticleSummaryDto,
  KnowledgeExamAnswerDto,
  KnowledgePathListDto,
  KnowledgePathStartDto,
} from '@server-models';
import {ILocalPageOutputDto} from '@shared/interfaces/orga-response.interface';
import {IGetKnowledgePathByIdPayload} from '../interfaces/knowledge-path-start-id-request.interface';
import {ISharedLocalBodyRequest} from "@shared/interfaces/shared-local-body-request.interface";

export const getPathItemsPaged = createAction(
  '[Shared Knowledge] Get Path Items paged',
  props<ISharedLocalBodyRequest>()
);

export const getPathItemsPagedCancel = createAction(
  '[Shared Knowledge] Get Path Items paged Cancel'
);

export const getPathItemsPagedSuccess = createAction(
  '[Shared Knowledge] Get Path Items paged success',
  props<{ data: ILocalPageOutputDto<KnowledgePathListDto[]> }>()
);

export const getPathItemsPagedFail = createAction(
  '[Shared Knowledge] Get Path Items paged fail',
  props<{ error: any }>()
);

export const getPathItemsPagedRefresh = createAction(
  '[Shared Knowledge] Get Path Items paged Refresh',
  props<{ data: ILocalPageOutputDto<KnowledgePathListDto[]> }>()
);

export const getKnowledgePathById = createAction(
  '[Shared Knowledge] Get Knowledge Path By Id',
  props<IGetKnowledgePathByIdPayload>()
);

export const getPathItemsByIdStartSuccess = createAction(
  '[Shared Knowledge] Get Path start by Id Success',
  props<{ data: KnowledgePathStartDto }>()
);

export const getPathItemsByIdStartFail = createAction(
  '[Shared Knowledge] Get Path start by Id Fail',
  props<{ error: any }>()
);

export const getPathItemsByIdStartRefresh = createAction(
  '[Shared Knowledge] Get Path start by Id Refresh',
  props<{ data: KnowledgePathStartDto }>()
);

export const getItemsSearched = createAction(
  '[Shared Knowledge] Get Searched',
  props<{ toSearch: string }>()
);

export const getItemsSearchedSuccess = createAction(
  '[Shared Knowledge] Get Searched Success',
  props<{ data: ILocalPageOutputDto<KnowledgeArticleListDto[]>; summary?: KnowledgeArticleSummaryDto; }>()
);

export const getItemsSearchedFail = createAction(
  '[Shared Knowledge] Get Searched Fail',
  props<{ error: any }>()
);

export const getArticlePage = createAction(
  '[Shared Knowledge] Get Article Page Start',
  props<{ articleId: number }>()
);

export const getArticlePageSuccess = createAction(
  '[Shared Knowledge] Get Article Page Success',
  props<{ data: KnowledgeArticleStartDto }>()
);

export const getArticlePageFail = createAction(
  '[Shared Knowledge] Get Article Page Fail',
  props<{ error: any }>()
);

export const getExamAnswerById = createAction(
  '[Shared Knowledge] Get Exam By Id',
  props<{ examId: string; pathId: string }>()
);

export const getExamAnswerByIdSuccess = createAction(
  '[Shared Knowledge] Get Exam By Id Success',
  props<{ data: KnowledgeExamAnswerDto }>()
);

export const getExamAnswerByIdFail = createAction(
  '[Shared Knowledge] Get Exam By Id Fail',
  props<{ error: any }>()
);

export const clearActiveExam = createAction('[Shared Knowledge] Clear Active Exam');

export const updateActiveExam = createAction(
  '[Shared Knowledge] Update Active Exam',
  props<{ data: KnowledgeExamAnswerDto }>()
);

export const submitExamAnswer = createAction(
  '[Shared Knowledge] Submit Exam',
  props<{ exam: KnowledgeExamAnswerDto }>()
);

export const submitExamAnswerSuccess = createAction(
  '[Shared Knowledge] Submit Exam Success',
  props<{ data: KnowledgeExamAnswerDto }>()
);

export const submitExamAnswerFail = createAction(
  '[Shared Knowledge] Submit Exam Fail',
  props<{ error: any }>()
);
